import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { UserCore } from "@highnote/server/src/core/entities";
import { highnote } from "@highnote/server/src/sdk";
import LoadingScreen from "App/common/LoadingScreen/LoadingScreen";
import { useAuth } from "App/components/Auth";
import { AuthRedirectRequired } from "App/modules/Auth/AuthRedirectRequired";
import { getAppDownloadUrl } from "App/modules/consts";
import { routePaths } from "App/modules/urls";
import { ArrayUnion } from "@highnote/server/src/core/entities";

const Handoff: React.FC = () => {
  const { user } = useAuth();
  const history = useHistory();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    const { spaceId, shareKey, trackId } = Object.fromEntries(
      searchParams.entries(),
    );

    if (!spaceId || !shareKey) {
      history.replace(routePaths.login);
      return;
    }

    if (spaceId && shareKey) {
      const data: UserCore["mobileHandoffSpace"] = {
        spaceId,
        shareKey,
      };

      if (trackId) {
        data.trackId = trackId;
      }

      highnote
        .updateUser({
          id: user?.id,
          data: {
            mobileHandoffSpace: data,
            pinnedSpaces: new ArrayUnion([spaceId]) as unknown as string[],
          },
        })
        .then(() => {
          window.location.href = getAppDownloadUrl();
        });
    }
  }, []);

  return <LoadingScreen />;
};

export const SpaceHandoff = () => (
  <AuthRedirectRequired>
    <Handoff />
  </AuthRedirectRequired>
);
